<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form
        :model="state.rlModel"
        label-width="auto"
        style="margin-top: 10px"
        ref="formDom"
      >
        <el-form-item label="未认领金额">
          <c_money :value="props.item?.uncollected_amount" :size="20" />
        </el-form-item>
        <div
          v-for="(model, index) in state.rlModel.bank_received_data"
          :key="model"
        >
          <div>
            <div style="display: flex; align-items: center">
              <el-form-item
                label="用途"
                prop="model.bank_received_type"
                :rules="[
                  {
                    required: true,
                    validator: (rule, value, callback) => {
                      if (model.bank_received_type) callback();
                      else callback(new Error('请选择认领用途'));
                    },
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="model.bank_received_type"
                  style="width: 150px"
                  @change="onTypeChange($event, model)"
                >
                  <el-option
                    v-for="item in state.typeData"
                    :key="item"
                    :label="item.name"
                    :value="item.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="金额">
                <el-input-number
                  v-model="model.collect_amount"
                  :controls="false"
                  class="number-input-left number-input-suffix"
                  :precision="2"
                  suffix="元"
                  :min="
                    model.bank_received_type != '其他'
                      ? 0
                      : Number.MIN_SAFE_INTEGER
                  "
                  style="width: 150px"
                  @focus="$onFocus"
                ></el-input-number>
              </el-form-item>
              <el-form-item
                label="工资表"
                prop="model.payroll_id"
                v-if="
                  ['工资', '个税', '服务费'].includes(model.bank_received_type)
                "
                style="flex: 1; margin-left: 10px"
                :rules="[
                  {
                    required:
                      ['工资', '个税'].includes(model.bank_received_type) &&
                      model.collect_amount > 0,
                    validator: (rule, value, callback) => {
                      if (
                        ['工资', '个税'].includes(model.bank_received_type) &&
                        model.collect_amount > 0 &&
                        !model.payroll_id
                      )
                        callback(new Error('请选择工资表'));
                      else callback();
                    },
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  v-model="model.payroll_id"
                  @change="onPayrollChange($event, model)"
                >
                  <el-option
                    v-for="item in state.payroll_data"
                    :key="item"
                    :label="`${item.order_id}_${item.name}_${item.settle_amount}`"
                    :value="item.id"
                  >
                    <div style="display: flex; align-items: center">
                      <li style="flex: 1">
                        <text style="color: #1e90ff">
                          ({{ item.order_id }})
                        </text>
                        <text>{{ item.name }}</text>
                      </li>
                      <div
                        style="
                          width: 200px;
                          display: flex;
                          column-gap: 10px;
                          overflow: hidden;
                        "
                      >
                        <div
                          style="
                            flex: 1;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <span
                            style="
                              color: #fff;
                              font-size: 11px;
                              background-color: #1e90ff;
                              border-radius: 2px;
                              margin-right: 3px;
                              cursor: pointer;
                              width: 15px;
                              height: 15px;
                              line-height: 15px;
                              text-align: center;
                            "
                            title="结算金额"
                            >结
                          </span>
                          <li style="flex: 1; overflow: hidden; color: #1e90ff">
                            {{ item.settle_amount }}
                          </li>
                        </div>
                        <div
                          style="
                            flex: 1;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <span
                            style="
                              color: #fff;
                              font-size: 11px;
                              background-color: #f00;
                              border-radius: 2px;
                              margin-right: 3px;
                              cursor: pointer;
                              width: 15px;
                              height: 15px;
                              line-height: 15px;
                              text-align: center;
                            "
                            title="欠款金额"
                            >欠
                          </span>
                          <li style="flex: 1; overflow: hidden; color: #f00">
                            {{ item.arrearage_amount }}
                          </li>
                        </div>
                      </div>
                    </div>
                  </el-option>
                  <template #footer>
                    <el-button size="small" @click="onLoadPayroll()">
                      刷新
                    </el-button>
                  </template>
                </el-select>
              </el-form-item>
              <li style="flex: 1" v-else></li>
              <el-button
                type="primary"
                link
                size="small"
                icon="plus"
                style="margin-bottom: 22px"
                @click="
                  state.rlModel.bank_received_data.splice(index + 1, 0, {
                    collect_remark: state.remark,
                  })
                "
              >
                添加
              </el-button>
              <el-button
                type="danger"
                link
                size="small"
                icon="delete"
                style="margin-bottom: 22px; margin-left: 0"
                @click="state.rlModel.bank_received_data.splice(index, 1)"
                >删除</el-button
              >
            </div>
            <el-form-item
              label="说明"
              prop="model.collect_remark"
              :rules="[
                {
                  required:
                    model.collect_amount > 0 &&
                    model.bank_received_type == '其他',
                  validator: (rule, value, callback) => {
                    if (
                      model.collect_amount > 0 &&
                      model.bank_received_type == '其他' &&
                      !model.collect_remark
                    )
                      callback(new Error('请填写认领说明'));
                    else callback();
                  },
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="model.collect_remark" size="large" />
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <template #label>
            <div style="display: flex; align-items: center; padding-left: 20px">
              <text>认领说明</text>
              <el-tooltip
                effect="dark"
                content="该项有内容时，后续添加的认领用途的分项说明系统将默认填入该项的内容，也可自行编辑"
                placement="top-start"
              >
                <el-icon style="cursor: pointer">
                  <QuestionFilled />
                </el-icon>
              </el-tooltip>
            </div>
          </template>
          <el-input v-model="state.remark">
            <template #suffix>
              <el-tooltip
                effect="dark"
                content="该项有内容时，点击该按钮，系统将自动把该内容填入到未填写的用途说明中"
                placement="top-start"
              >
                <el-button
                  size="small"
                  type="primary"
                  @click="onRemarkBlur(false)"
                >
                  自动带入
                </el-button>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                content="该项有内容时，点击该按钮，系统将强制覆盖所有用途的说明，无论分项用途说明是否已填写"
                placement="top-start"
              >
                <el-button
                  size="small"
                  type="warning"
                  @click="onRemarkBlur(true)"
                >
                  强制覆盖
                </el-button>
              </el-tooltip>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">暂存</el-button>
      <el-button type="info" @click="onClose">取消</el-button>
      <text style="margin-left: 10px; color: #f00"
        >注：暂存时系统将自动忽略未填写金额的认领用途项</text
      >
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { bankcollected_getpayroll } from "@/http/bankcollected";
import { bankcollected_receivedtype_select } from "@/http/dictionary";
import { ElMessage } from "element-plus";

export default {
  props: {
    customer_id: Number,
    item: Object,
    payroll_data: Array,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      rlModel: {},
    });
    onMounted(() => {
      state.payroll_data = props.payroll_data;
      bankcollected_receivedtype_select().then((res) => {
        if (res.status == 200) state.typeData = res.data.data;
      });

      onLoadPayroll();

      if (props.item?.bank_received_data?.length > 0)
        state.rlModel.bank_received_data = props.item?.bank_received_data;
      else
        state.rlModel.bank_received_data = [
          {
            bank_received_type: "工资",
          },
          {
            bank_received_type: "个税",
          },
          {
            bank_received_type: "服务费",
          },
          {
            bank_received_type: "社保",
          },
          {
            bank_received_type: "公积金",
          },
        ];
    });

    const onTypeChange = (value, model) => {
      if (value != "工资") {
        delete model.payroll_id;
      }
    };

    const onLoadPayroll = () => {
      bankcollected_getpayroll({ customer_id: props.customer_id }).then(
        (res) => {
          if (res.status == 200) state.payroll_data = res.data.data?.list;
        }
      );
    };

    const onPayrollChange = (id, model) => {
      const payroll = state.payroll_data?.find((w) => w.id == id);
      if (payroll) {
        model.payroll_name = `<li style='margin-right:10px;'>${payroll.name}</li><span class='bankcollected-add-tag' style='background-color: #1e90ff;'>结</span><text style='color: #1e90ff;'>${payroll.settle_amount}</text><span class='bankcollected-add-tag' style='background-color: #f00;margin-left:10px'>欠</span><text style='color: #f00;'>${payroll.arrearage_amount}</text>`;
      }

      switch (model.bank_received_type) {
        case "工资":
          model.collect_amount = parseFloat(payroll.arrearage_amount);
          break;
        case "个税":
          model.collect_amount = parseFloat(
            payroll.personal_income_tax || payroll.company_income_tax
          );
          break;
        case "服务费":
          model.collect_amount = parseFloat(
            payroll.withhold_service_fee || payroll.standard_service_fee
          );
          break;
        default:
          break;
      }
    };

    const onClose = () => {
      emit("close");
    };

    const onSubmit = () => {
      console.log(state.rlModel.bank_received_data);

      formDom.value.validate((valid) => {
        if (valid) {
          const unamounts = state.rlModel.bank_received_data.filter(
            (w) => typeof w.collect_amount !== "number"
          );

          if (unamounts.length == state.rlModel.bank_received_data?.length) {
            ElMessage({
              type: "warning",
              message: "请至少填写一项认领用途的认领金额！",
              grouping: true,
            });
            return false;
          }

          const totalAmount = state.rlModel.bank_received_data.reduce(
            (acc, cur) => {
              return (acc +=
                typeof cur.collect_amount === "number"
                  ? parseFloat(cur.collect_amount)
                  : 0);
            },
            0
          );

          if (
            parseFloat(totalAmount.toFixed(2)) >
            parseFloat(props.item?.uncollected_amount || 0)
          ) {
            ElMessage.warning(`认领金额超出到款记录未认领金额！`);
            return false;
          }

          emit(
            "confirm",
            state.rlModel.bank_received_data.filter(
              (w) => typeof w.collect_amount == "number"
            )
          );
        }
      });
    };

    const onRemarkBlur = (status) => {
      if (state.remark) {
        state.rlModel.bank_received_data.forEach((item) => {
          if (!item.collect_remark || status) {
            item.collect_remark = state.remark;
          }
        });
      }
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onTypeChange,
      onRemarkBlur,
      onLoadPayroll,
      onClose,
      onPayrollChange,
    };
  },
};
</script>
<style scoped lang="less">
.cus-desc {
  & > div {
    width: 25%;
  }
}
</style>
